module.exports = __webpack_public_path__ + "static/gitlet-01164e93d917c301bdae9efbb5e19bbd.png";